// Centralized API URL handling for both local dev and deployed environments.
//
// - In development (react-scripts start), default to the local backend.
// - In production, default to same-origin (so an nginx reverse-proxy can route /run-origami, /genomes, /output, /download).
// - Override anytime via REACT_APP_API_BASE, e.g.:
//   REACT_APP_API_BASE=https://your-backend.example.com

const trimTrailingSlashes = (s) => String(s).replace(/\/+$/, "");

export const API_BASE = (() => {
  const env = process.env.REACT_APP_API_BASE;
  if (env && String(env).trim()) return trimTrailingSlashes(env.trim());

  // CRA dev server
  if (process.env.NODE_ENV === "development") return "http://127.0.0.1:8000";

  // Production: prefer same-origin so it works behind a reverse proxy.
  return "";
})();

// CRA builds bake PUBLIC_URL from package.json "homepage" (or env PUBLIC_URL).
// In this repo, Router uses basename="/sharmaglab/origenomi".
//
// In some deployments (especially when serving a prebuilt artifact via a custom
// server), PUBLIC_URL may be unset even though the app is hosted under a subpath.
// Default to the router basename to avoid calling "/run-origami" at the site root.
const DEFAULT_APP_BASE =
  process.env.NODE_ENV === "production" ? "/sharmaglab/origenomi" : "";
const APP_BASE = trimTrailingSlashes(process.env.PUBLIC_URL || DEFAULT_APP_BASE);

export const apiUrl = (path) => {
  if (!path) return API_BASE;
  if (/^https?:\/\//i.test(path)) return path; // already absolute
  const p = String(path).startsWith("/") ? String(path) : `/${path}`;
  if (API_BASE) return `${API_BASE}${p}`;
  return `${APP_BASE}${p}`;
};

// Some DB rows historically stored plot paths with Postgres-array or brace wrappers,
// e.g. {"{/output/...png}"} or {/output/...png}. Normalize those to "/output/...png".
export const normalizeAssetPath = (path) => {
  if (!path) return path;
  let s = String(path).trim();
  if (!s) return s;

  // strip one level of quotes
  if (
    (s.startsWith('"') && s.endsWith('"')) ||
    (s.startsWith("'") && s.endsWith("'"))
  ) {
    s = s.slice(1, -1).trim();
  }

  // strip one level of braces around a single path
  if (s.startsWith("{") && s.endsWith("}") && s.includes("/output/")) {
    s = s.slice(1, -1).trim();
  }

  // if it contains an embedded /output/... somewhere, drop any leading junk
  const idx = s.indexOf("/output/");
  if (idx !== -1 && idx !== 0) s = s.slice(idx);

  return s;
};


